import styled from "styled-components";
import { ProductOrBrand } from "../model/alternativeTypes";
import Checkbox from "../components/Checkbox";

interface ProductTileProps {
  flyerLocale: string;
  categoryName: string;
  product: ProductOrBrand;
  onChange: (update: ProductOrBrand) => void;
}

const ProductTile: React.FC<ProductTileProps> = ({ categoryName, product, onChange }) => {
  return (
    <ProductContainer>
      <Checkbox 
        id={categoryName + "." + product.name}
        checked={product.include || false}
        onChange={() => onChange({
          ...product,
          include: !product.include
        })}
        label={product.name}
      />
    </ProductContainer>
  )
}

const ProductContainer = styled.div`
  display: flex;
  gap: 5px;
`;


export default ProductTile;